import { render } from "./carousel.vue?vue&type=template&id=5c24cb32"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"

import "./carousel.vue?vue&type=style&index=0&id=5c24cb32&lang=scss"

import exportComponent from "/home/runner/work/cinema_vue/cinema_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__